import { useSelector } from "react-redux";

import { selectCurrentUser } from "../../store/reducers/user";

export const useVerifyForm = (additionalCondition?: boolean) => {
  const { kyc_complete_and_approved, kyc_second_level_complete_and_approved } =
    useSelector(selectCurrentUser);

  const showVerifyForm =
    (!kyc_complete_and_approved || !kyc_second_level_complete_and_approved) &&
    additionalCondition;

  return showVerifyForm;
};
